<template>
  <right-menu-item
    @click.prevent="click"
    :class="{'!text-red-600': !loading && isActive, 'muted': !isActive}"
    :text="$t('Delete team')"
    :loading="loading"
    icon="trash"
  />
</template>

<script>
import {mapStores} from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import {showConfirm} from '../../components/BcConfirm.vue'
import NetteAjax from "nette-base-module/js/nette/NetteAjax"
import { trackEvent } from '../../gtm'

export default {
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    isActive() {
      return this.bcSelectedStore.listSelected.length == 0
    },
    ...mapStores(useBcSelectedStore),
  },
  methods: {
    async click() {
      const confirm = await showConfirm({
        header: this.$t('Do you want to delete this team?'),
      })

      if (!confirm) {
        return
      }

      this.loading = true
      await NetteAjax.ajax(this.$presenterInfo.url.split('?')[0] + "?do=deleteTeam")
      this.loading = false
      trackEvent(this.$route.matched[0].name, 'deleteTeam')
    }
  },
}
</script>

<style lang="scss" scoped></style>